import {createFileRoute, redirect} from '@tanstack/react-router';

/** Legacy redirect: /profile/calendar → /dashboard/calendar. */
export const Route = createFileRoute('/profile/calendar')({
  beforeLoad: () => {
    throw redirect({to: '/dashboard/calendar'});
  },
});
